import React from 'react';
import { Input, Button, Tag, Tooltip } from 'antd';
import { observer } from 'mobx-react';
import { Trans, useTranslation } from 'react-i18next';
import { LoadingOutlined, CloseOutlined } from '@ant-design/icons';
import { isMediaMessage, isRegularMessage } from '@whatsper/texterchat-common';
import { getDirection } from '../../../../../helpers';
import { useStore } from '../../../../../store/rootStore';
import styles from './ChatNoteInput.module.scss';
const ChatNoteInput = ({ noteText, loading, handleSetText, handleAddNote, inputRef, selectedMessageId, handleRemoveReference, editingNote, handleCancelEdit, disabled, }) => {
    const { activeChatStore } = useStore();
    const { t } = useTranslation();
    const message = activeChatStore.messages.find((message) => message._id === selectedMessageId);
    const parseMessagePreview = () => {
        let preview = '';
        if (!message) {
            return preview;
        }
        if (isRegularMessage(message)) {
            if (isMediaMessage(message)) {
                preview = message.media[0].filename || message.media[0].mediaType;
            }
            else {
                preview = message.text || '';
            }
        }
        return preview.slice(0, 24);
    };
    return (React.createElement("div", { className: styles.container },
        selectedMessageId && (React.createElement("div", { className: styles.referenceContainer },
            React.createElement(Tag, { closable: true, onClose: handleRemoveReference, color: "green", closeIcon: React.createElement(Tooltip, { title: React.createElement(Trans, { i18nKey: "removeReferenceTooltip" }), placement: getDirection() === 'rtl' ? 'topLeft' : 'topRight' },
                    React.createElement(CloseOutlined, { style: { color: 'red' } })), className: styles.referenceTag },
                React.createElement(Trans, { i18nKey: "referenceTo", values: { text: parseMessagePreview() } })))),
        React.createElement(Input.TextArea, { ref: inputRef, autoSize: { minRows: 3 }, className: styles.textarea, placeholder: t('notePlaceholder'), disabled: loading || disabled, value: noteText, onChange: (e) => {
                handleSetText(e.target.value);
            } }),
        React.createElement("div", { className: styles.buttonsContainer },
            editingNote && (React.createElement(Button, { className: styles.cancelButton, onClick: handleCancelEdit, size: "small" },
                React.createElement(Trans, { i18nKey: "cancel" }))),
            React.createElement(Button, { className: styles.addNoteButton, disabled: !noteText || loading || disabled, onClick: handleAddNote, loading: loading, type: "primary", size: "small", icon: loading ? React.createElement(LoadingOutlined, null) : null },
                React.createElement(Trans, { i18nKey: editingNote ? 'save' : 'addNote' })))));
};
export default observer(ChatNoteInput);
